import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles({
  container: {
    width: '100%',
  },
  overflowContainer: {
    display: 'grid',
    gridTemplateRows: '1fr 1fr 1fr 1fr',
    transition: '.5s ease-in-out',
    gridGap: '1rem',
    maxWidth: '100%',
    marginLeft: '1rem',
    // marginTop: '14px',
    height: '80vh',
    overflowY: 'scroll',

    justifyContent: 'space-between',
    alignItems: 'center',
    '& .MuiAccordionDetails-root': {
      paddingTop: '0',
      justifyContent: 'center',
      maxWidth: '100%',
    },

    // chart status
    '& > div:last-child': {
      maxWidth: '30vw',
    },
  },
  chartAccordion: {
    width: '260px',
  },
});

export default useStyles;
